import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { editContentRow, getContentRow, getPage, resetPages } from '../../../redux/actions/pagesActions'
import TextFieldGroup from '../../common/TextFieldGroup'
import SelectFieldGroup from '../../common/SelectFieldGroup'
import analysisIcon from '../../../assets/img/analysis.svg'
import { Theme } from '../../../utils/Theme'
import { withStyles } from '@material-ui/styles'
import Header from '../../layout/Partials/Header'
import { withRouter } from 'react-router-dom'
import Loading from '../../common/Loading'
import AdminLayout from '../../layout/AdminLayout'

const styles = Theme()

class EditRow extends Component {
  constructor(props) {
    super(props)
    this.state = {
      columns: '1',
      height: '100',
      sort: '1',
      page: null,
      loading: true,
      initialLoad: true,
    }
    this.onResourceSelect = this.onResourceSelect.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let { height, columns, sort, page, loading, initialLoad } = prevState
    let { pages } = nextProps

    if (!pages.loading && pages.content_row && initialLoad) {
      height = pages.content_row.height.toString()
      columns = pages.content_row.columns
      page = pages.page
      sort = pages.content_row.sortOrder
      loading = false
      initialLoad = false
    }

    return { height, columns, page, loading, initialLoad, sort }
  }

  onSubmit = e => {
    e.preventDefault()
    const { page, row } = this.props.match.params
    const { columns, height, sort } = this.state
    const data = { page, columns, height, sort }

    this.props.editContentRow(page, row, data, this.props.history)
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onResourceSelect = e => {
    e.preventDefault()
    this.setState({ columns: e.target.value })
  }

  componentDidMount() {
    const page = this.props.match.params.page
    const row = this.props.match.params.row

    this.props.getContentRow(page, row)
    this.props.getPage(page)
    this.setState({ initialLoad: true })
  }

  componentWillUnmount() {
    this.props.resetPages()
  }

  createPreviewCols = () => {
    let cols = []
    const { columns, height } = this.state

    for (let i = 0; i < columns; i++) {
      cols.push(
        <div
          className={`c-card u-m-zero u-text-center`}
          style={{
            height: `${height}px`,
          }}
        >
          <img
            alt={'preview icon'}
            src={analysisIcon}
            style={{
              width: 'auto',
              height: `${parseInt(height) - 20}px`,
            }}
            className={'u-m-auto'}
          />
        </div>
      )
    }

    return (
      <div className={'row u-m-zero'}>
        {cols.map((col, index) => (
          <div key={index} className={'col'}>
            {' '}
            {col}
          </div>
        ))}
      </div>
    )
  }

  render() {
    const { columns, height, loading, sort } = this.state
    const { classes } = this.props

    return (
      <AdminLayout>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">Edit Row</h2>
          </Header>
          {!loading ? (
            <div className="u-mr-small u-ml-small">
              <div className={'c-card u-m-zero'}>
                <div className="o-line c-card__title">
                  <div>
                    <h3 className={'c-card__title'}>Edit Row</h3>
                  </div>
                  <div>
                    <button className={`c-btn ${classes.buttonSecondary}`} onClick={e => this.props.history.goBack()}>
                      Cancel
                    </button>
                  </div>
                </div>
                <div className={'c-divider u-mt-small u-mb-small'} />
                <form onSubmit={this.onSubmit}>
                  <div className={'row'}>
                    <div className={'col-sm-4'}>
                      <SelectFieldGroup
                        options={[
                          { key: '1', title: 'One' },
                          { key: '2', title: 'Two' },
                          { key: '3', title: 'Three' },
                          { key: '4', title: 'Four' },
                          { key: '5', title: 'Five' },
                          { key: '6', title: 'Six' },
                        ]}
                        label={'Number of columns'}
                        disabled={true}
                        type={'text'}
                        onChange={this.onResourceSelect}
                        value={columns}
                        name={'columns'}
                      />
                    </div>
                    <div className={'col-sm-4'}>
                      <TextFieldGroup
                        label={'Objects Height (px)'}
                        value={height}
                        onChange={this.onChange}
                        name={'height'}
                      />
                    </div>
                    <div className={'col-sm-4'}>
                      <TextFieldGroup label={'Sort Order'} value={sort} onChange={this.onChange} name={'sort'} />
                    </div>
                    <div className={'col-sm-4'} style={{ paddingTop: '23px' }}>
                      <button className={`c-btn c-btn--fullwidth ${classes.buttonPrimary}`}>Update Row</button>
                    </div>
                  </div>
                </form>
              </div>

              <div className={'c-card u-mt-small u-text-center'}>
                <div className="o-line c-card__title">
                  <h4 className={'c-card__title text-center text-muted'}>Preview</h4>
                </div>
                <div className={'c-card__body u-p-zero'}>{this.createPreviewCols()}</div>
              </div>
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </AdminLayout>
    )
  }
}

EditRow.propTypes = {
  editContentRow: PropTypes.func.isRequired,
  getContentRow: PropTypes.func,
  resetPages: PropTypes.func,
  getPage: PropTypes.func,
  pages: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  match: PropTypes.object,
  history: PropTypes.object,
  classes: PropTypes.object,
}

const mapStateToProps = state => ({
  pages: state.pages,
  errors: state.errors,
})

export default connect(mapStateToProps, {
  editContentRow,
  getContentRow,
  resetPages,
  getPage,
})(withRouter(withStyles(styles)(EditRow)))
